<div class="persona-picker-container" *ngIf="ready">
  <div class="persona-picker-header">
    <div class="persona-picker-welcome">Welcome Back, {{ selfPersona.first_name }}!</div>
    <h2 *ngIf="header" class="persona-picker-title">{{ header }}</h2>
  </div>
  <se-po-persona-picker #picker
    (pick)="onPick($event)"
    (edit)="onEdit($event)"
    [profiles]="managedProfiles"
  ></se-po-persona-picker>

  <div class="add-profile-btn" *ngIf="permissions.selfIsAdult">
    <se-fe-chip
      seFeDataText="Add new child"
      seFeDataIconLeft="plus_circle_outline"
      seFeDataStyle="primary"
      (seFeClick)="onAddProfileClick($event)"
    ></se-fe-chip>
  </div>

  <se-fe-modal #addProfileModal>
    <div seFeModalContent class="modal-content">
      <se-po-add-child-profile #childInfo
        [ngClass]="{active: addChildStep === 1, inactive: addChildStep !== 1}"
      ></se-po-add-child-profile>
      <se-po-add-child-contact-info #childContactInfo
        [ngClass]="{active: addChildStep === 2}"
        [persona]="addPersona"
      ></se-po-add-child-contact-info>
    </div>
    <div seFeModalFooter>
      <se-fe-modal-footer #addProfileFooter
        [seFeDataFooterButtons]="addProfileButtons"
      ></se-fe-modal-footer>
    </div>
  </se-fe-modal>

  <se-po-edit-persona-modal #editPersonaModal
    [showContactInfo]="editInfoProfile?.relationship === 'self'"
    (personaEdited)="onPersonaSave()">
  </se-po-edit-persona-modal>
</div>
